"use client";

import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import AlertMsg from "@/components/dialogs/common/AlertMsg";
import { UploadsImagesWithPreview } from "@/components/common/Dropzone";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  useGetPresignedURLQuery,
  useUpdateTenantBrandingMutation,
} from "@/store/slices/apiSlice";
import { uploadToS3 } from "@/utils";

const initAlertMsg = {
  open: false,
  label: "",
  msg: "",
  isError: false,
  isLoading: false,
  btnText: "",
  canClose: false,
};

const ChangeBrandLogoDialog = ({
  open,
  onClose,
  tenantId,
  currentLogo = null,
  onSuccess,
  organisationDetails,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [logoFile, setLogoFile] = useState(currentLogo);
  const [error, setError] = useState("");
  const [alertMsg, setAlertMsg] = useState(initAlertMsg);
  const [logoFileId, setLogoFileId] = useState(null);
  const [updateTenantBranding] = useUpdateTenantBrandingMutation();
  const { data: presignedUrlData, refetch: refetchPresignedUrl } =
    useGetPresignedURLQuery(
      {
        tenantId,
        fileName: logoFile?.name,
        contentType: logoFile?.type,
      },
      {
        skip: !(logoFile instanceof File),
      },
    );

  const isAddMode = !currentLogo;
  useEffect(() => {
    const uploadLogo = async () => {
      const uploadUrl = presignedUrlData?.response?.data?.uploadUrl;

      const objectUrl = presignedUrlData?.response?.data?.objectUrl;

      if (logoFile && uploadUrl) {
        try {
          setIsLoading(true);

          const success = await uploadToS3(logoFile, uploadUrl);

          if (!success) {
            throw new Error("S3 upload failed");
          }

          setLogoFileId(objectUrl);
        } catch (err) {
          setError("Image upload failed");
        } finally {
          setIsLoading(false);
        }
      }
    };

    uploadLogo();
  }, [logoFile, presignedUrlData]);
  // useEffect(() => {
  //   const uploadLogo = async () => {
  //     const uploadUrl = presignedUrlData?.response?.data?.uploadUrl;

  //     const objectUrl = presignedUrlData?.response?.data?.objectUrl;

  //     if (logoFile && uploadUrl) {
  //       try {
  //         setIsLoading(true);

  //         // Upload to S3
  //         const success = await uploadToS3(logoFile, uploadUrl);

  //         if (!success) {
  //           throw new Error("S3 upload failed");
  //         }

  //         // optionally save object url
  //         setLogoFileId(objectUrl);
  //       } catch (err) {
  //         console.error("Upload failed", err);
  //         setError("Image upload failed");
  //       } finally {
  //         setIsLoading(false);
  //       }
  //     }
  //   };

  //   uploadLogo();
  // }, [logoFile, presignedUrlData]);
  // useEffect(() => {
  //   if (open) {
  //     setLogoFile(currentLogo);
  //     setError("");
  //   }
  // }, [open, currentLogo]);

  const handleClose = () => {
    if (isLoading) return;

    setLogoFile(currentLogo);
    setError("");
    onClose?.();
  };

  const handleAlertClose = () => {
    const wasError = alertMsg.isError;

    setAlertMsg(initAlertMsg);

    if (!wasError) {
      onClose?.();
    }
  };
  const validateImageRatio = (file) => {
    return new Promise((resolve) => {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = () => {
        const isSquare = img.width === img.height;

        URL.revokeObjectURL(objectUrl);
        resolve(isSquare);
      };

      img.src = objectUrl;
    });
  };
  const handleSubmit = async () => {
    if (!logoFileId) {
      setError("Please upload logo properly.");
      return;
    }

    try {
      setIsLoading(true);

      const payload = {
        logoUrl: logoFileId,
        primaryColor: organisationDetails?.branding?.primaryColor,
        secondaryColor: organisationDetails?.branding?.secondaryColor,
      };

      const res = await updateTenantBranding({
        tenantId,
        payload,
      }).unwrap();

      if (res?.response?.statusEnum === 1) {
        onSuccess?.(payload);
        setAlertMsg({
          open: true,
          label: "Brand Logo Updated Successfully",
          msg:
            res?.response?.message ||
            "Brand logo has been updated successfully.",
          isError: false,
          btnText: "Close",
          canClose: false,
        });
      } else {
        setAlertMsg({
          open: true,
          label: "Update Failed",
          msg: res?.response?.message || "Unable to update brand logo.",
          isError: true,
          btnText: "Close",
          canClose: false,
        });
      }
    } catch (err) {
      setAlertMsg({
        open: true,
        label: "Update Failed",
        msg:
          err?.data?.response?.message ||
          "Something went wrong. Please try again.",
        isError: true,
        btnText: "Close",
        canClose: false,
      });
    } finally {
      setIsLoading(false);
    }
  };
  const handleSubmit2 = async () => {
    if (!logoFileId) {
      setError("Please upload logo properly.");
      return;
    }

    try {
      setIsLoading(true);

      const payload = {
        tenantId,
        fileId: logoFileId, // 🔥 IMPORTANT (logo nahi bhejna, fileId bhejna hai)
      };

      // REAL API CALL
      // const res = await updateBrandLogo(payload).unwrap();

      const res = {
        response: {
          statusEnum: 1,
          message: "Brand logo has been updated successfully.",
        },
      };

      if (res?.response?.statusEnum === 1) {
        onSuccess?.(payload);

        setAlertMsg({
          open: true,
          label: "Brand Logo Updated Successfully",
          msg: res?.response?.message,
          isError: false,
          btnText: "Close",
          canClose: false,
        });
      } else {
        throw new Error(res?.response?.message);
      }
    } catch (err) {
      setAlertMsg({
        open: true,
        label: "Update Failed",
        msg: err?.message || "Something went wrong",
        isError: true,
        btnText: "Close",
        canClose: false,
      });
    } finally {
      setIsLoading(false);
    }
  };
  const handleSubmit1 = async () => {
    if (!logoFile) {
      setError("Please upload a logo.");
      return;
    }

    try {
      setIsLoading(true);

      const payload = {
        tenantId,
        logo: logoFile,
      };

      /*
        Replace this fake response with your real API mutation later:

        const formData = new FormData();
        formData.append("tenantId", tenantId);
        formData.append("logo", logoFile);

        const res = await updateBrandLogo(formData).unwrap();
      */

      const res = {
        response: {
          statusEnum: 1,
          message: "Brand logo has been updated successfully.",
        },
      };

      if (res?.response?.statusEnum === 1) {
        onSuccess?.(payload);

        setAlertMsg({
          open: true,
          label: "Brand Logo Updated Successfully",
          msg:
            res?.response?.message ||
            "Brand logo has been updated successfully.",
          isError: false,
          btnText: "Close",
          canClose: false,
        });
      } else {
        setAlertMsg({
          open: true,
          label: "Update Failed",
          msg:
            res?.response?.message ||
            "Unable to update brand logo. Please try again.",
          isError: true,
          btnText: "Close",
          canClose: false,
        });
      }
    } catch (err) {
      setAlertMsg({
        open: true,
        label: "Update Failed",
        msg:
          err?.data?.response?.message ||
          "Something went wrong. Please try again.",
        isError: true,
        btnText: "Close",
        canClose: false,
      });

      console.error("Update brand logo error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Dialog open={open} onOpenChange={handleClose}>
        <DialogContent className="w-[calc(100vw-32px)] max-w-[900px] max-h-[92vh] overflow-y-auto rounded-lg border bg-brand-10 border-brand-11 px-5 py-8 text-neutral-100 shadow-2xl sm:px-10 lg:px-14">
          <DialogHeader className="mb-7 text-left">
            <DialogTitle className="text-left text-2xl font-bold text-[#67D8FF]">
              {/* Edit Brand Logo */}
              {isAddMode ? "Add Brand Logo" : "Change Brand Logo"}
            </DialogTitle>

            <DialogDescription className="sr-only">
              Upload brand logo
            </DialogDescription>
          </DialogHeader>

          <div>
            {/* <p className="mb-3 text-sm font-bold text-neutral-100">
              Upload Logo
            </p> */}
            <UploadsImagesWithPreview
              placeholder="Upload logo"
              fileFormat="Upload logo (PNG, JPG)"
              value={logoFile}
              onChange={(val) => {
                setLogoFile(val);
                if (val) setError("");
              }}
              // onChange={async (val) => {
              //   if (val instanceof File) {
              //     const isValidRatio = await validateImageRatio(val);

              //     if (!isValidRatio) {
              //       setError("Only 1:1(square) ratio image is allowed.");
              //       return;
              //     }
              //   }

              //   setLogoFile(val);

              //   if (val) setError("");
              // }}
              setError={(msg) => setError(msg)}
            />
            {/* <UploadsImagesWithPreview
              placeholder="Upload logo"
              fileFormat="Upload logo (PNG, JPG) | 1:1 ratio"
              value={logoFile}
              onChange={(val) => {
                setLogoFile(val);
                if (val) setError("");
              }}
              setError={(msg) => setError(msg)}
            /> */}

            {error && <p className="mt-2 text-sm text-red-400">{error}</p>}
          </div>

          <DialogFooter className="mt-10 flex flex-col gap-3 sm:flex-row sm:justify-end">
            <Button
              type="button"
              variant="outline"
              onClick={handleClose}
              disabled={isLoading}
              className="h-11 w-full border-[#607A9B] bg-[#223957] px-8 font-bold text-neutral-100 hover:bg-[#2B466B] hover:text-neutral-100 sm:w-auto"
            >
              Go back
            </Button>

            <Button
              type="button"
              onClick={handleSubmit}
              disabled={isLoading}
              className="h-11 w-full bg-brand-21 px-8 font-bold text-neutral-100 hover:bg-brand-22 sm:w-auto"
            >
              {isLoading ? "Saving..." : "Save Changes"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <AlertMsg
        label={alertMsg.label}
        msg={alertMsg.msg}
        open={alertMsg.open}
        onClose={handleAlertClose}
        confirmAction={handleAlertClose}
        isLoading={false}
        isError={alertMsg.isError}
        canClose={alertMsg.canClose}
        confirmationBtnText={alertMsg.btnText}
      />
    </>
  );
};

export default ChangeBrandLogoDialog;
